<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="load">
      <el-form-item label="父物料">
        <el-input v-model="form.materialCode" readonly size="small" style="width:180px" placeholder="点击选择">
          <el-button slot="append" @click="openMaterialPicker('parent')">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="左类型">
        <el-select v-model="form.bomTypeLeft" size="small" style="width:90px">
          <el-option label="EBOM" value="ebom" /><el-option label="MBOM" value="mbom" />
        </el-select>
      </el-form-item>
      <el-form-item label="左版本"><el-input v-model="form.versionLeft" size="small" style="width:80px" /></el-form-item>
      <el-form-item label="右类型">
        <el-select v-model="form.bomTypeRight" size="small" style="width:90px">
          <el-option label="EBOM" value="ebom" /><el-option label="MBOM" value="mbom" />
        </el-select>
      </el-form-item>
      <el-form-item label="右版本"><el-input v-model="form.versionRight" size="small" style="width:80px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmBomCompare:list')" type="primary" size="small" @click="load">对比</el-button>
      </el-form-item>
    </el-form>
    <el-alert v-if="compareError" :title="compareError" type="warning" :closable="false" show-icon style="margin-bottom:12px" />
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="55" header-align="center" align="center" />
      <el-table-column prop="changeType" label="变更" width="80" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="changeTagType(scope.row.changeType)">{{ changeLabel(scope.row.changeType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="childMaterialCode" label="子件编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="childMaterialName" label="子件名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="quantityBefore" label="原用量" width="90" header-align="center" align="right" />
      <el-table-column prop="quantityAfter" label="新用量" width="90" header-align="center" align="right" />
      <el-table-column prop="lossBefore" label="原损耗%" width="90" header-align="center" align="right" />
      <el-table-column prop="lossAfter" label="新损耗%" width="90" header-align="center" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <div class="where-used-block">
      <div class="block-title">反查 Where-used</div>
      <el-form :inline="true">
        <el-form-item label="子件物料">
          <el-input v-model="whereUsedMaterialCode" readonly size="small" style="width:200px" placeholder="点击选择">
            <el-button slot="append" @click="openMaterialPicker('whereUsed')">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="BOM类型">
          <el-select v-model="whereUsedBomType" clearable size="small" style="width:100px">
            <el-option label="全部" value="" />
            <el-option label="EBOM" value="ebom" />
            <el-option label="MBOM" value="mbom" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button v-if="isAuth('plm:plmBomCompare:list')" type="primary" size="small" :loading="whereUsedLoading" @click="loadWhereUsed">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="whereUsedList" border size="small" v-loading="whereUsedLoading" :header-cell-style="headStyle">
        <el-table-column prop="materialCode" label="父件编码" min-width="120" />
        <el-table-column prop="materialName" label="父件名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="bomVersion" label="版本" width="90" align="center" />
        <el-table-column prop="bomType" label="类型" width="80" align="center" />
        <el-table-column prop="approveStatus" label="审批" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.approveStatus === '2' ? '已审' : '未审' }}</template>
        </el-table-column>
        <el-table-column prop="releaseStatus" label="发布" width="80" align="center">
          <template slot-scope="scope">{{ scope.row.releaseStatus === '1' ? '是' : '否' }}</template>
        </el-table-column>
      </el-table>
    </div>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmBomCompare',
  components: { MaterialSelector },
  data() {
    return {
      form: {
        materialId: '', materialCode: '',
        bomTypeLeft: 'ebom', versionLeft: 'V1',
        bomTypeRight: 'mbom', versionRight: 'V1'
      },
      list: [], pageIndex: 1, pageSize: 20, loading: false, compareError: '', permCodes: [],
      whereUsedMaterialId: '', whereUsedMaterialCode: '', whereUsedBomType: '', whereUsedList: [], whereUsedLoading: false,
      materialSelectorVisible: false, materialPickTarget: '',
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  computed: {
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    changeLabel(t) {
      const map = { add: '新增', delete: '删除', change: '修改' }
      return map[t] || t
    },
    changeTagType(t) {
      if (t === 'add') return 'success'
      if (t === 'delete') return 'danger'
      return 'warning'
    },
    openMaterialPicker(target) {
      this.materialPickTarget = target
      this.materialSelectorVisible = true
    },
    onMaterialSelect(row) {
      if (this.materialPickTarget === 'parent') {
        this.form.materialId = row.materialId
        this.form.materialCode = row.materialCode
      } else if (this.materialPickTarget === 'whereUsed') {
        this.whereUsedMaterialId = row.materialId
        this.whereUsedMaterialCode = row.materialCode
      }
      this.materialSelectorVisible = false
    },
    load() {
      if (!this.form.materialId || !this.form.versionLeft || !this.form.versionRight) {
        this.$message.warning('请选择父物料并填写完整对比参数')
        return
      }
      this.pageIndex = 1
      this.compareError = ''
      this.loading = true
      request.get('/plm/compare/list', {
        params: {
          materialId: this.form.materialId,
          bomTypeLeft: this.form.bomTypeLeft,
          versionLeft: this.form.versionLeft,
          bomTypeRight: this.form.bomTypeRight,
          versionRight: this.form.versionRight
        }
      }).then(res => { this.list = res.data || [] }).catch(err => { this.list = []; this.compareError = err.message || '对比失败' }).finally(() => { this.loading = false })
    },
    loadWhereUsed() {
      if (!this.whereUsedMaterialId) {
        this.$message.warning('请选择子件物料')
        return
      }
      this.whereUsedLoading = true
      request.get('/plm/compare/whereUsed', {
        params: { childMaterialId: this.whereUsedMaterialId, bomType: this.whereUsedBomType || '' }
      }).then(res => { this.whereUsedList = res.data || [] }).catch(() => { this.whereUsedList = [] }).finally(() => { this.whereUsedLoading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.where-used-block { margin-top: 20px; }
.block-title { font-weight: 600; margin-bottom: 8px; }
</style>
